import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import {
  blueGreyMui,
  greyMui,
  lightBlueMui,
  orangeMui,
  purpleMui,
  redMui,
  tealMui,
} from "@ryde/theme";

export const VehicleOccupancyWrapperStyled = styled.span.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "vehicle-occupancy-wrapper-cell",
  },
)`
  color: ${blueGreyMui._500};
  display: flex;
  align-items: center;
  font-weight: 600;
  width: 58px;
  svg {
    margin-inline-end: 3px;
  }
  span.green {
    color: ${tealMui.A700};
  }
  span.red {
    color: ${redMui.A400};
  }
  span.blue {
    color: ${lightBlueMui._700};
  }
  span.yellow {
    color: ${orangeMui.A400};
  }
`;

export const UserInfoContainerStyled = styled.span.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "user_info_container",
})<{ $isToday: boolean }>`
  display: flex;
  align-items: center;
  .time_label {
    font-size: 11px;
    line-height: 2px;
    margin-inline-end: 3px;
    color: ${({ $isToday }) =>
      $isToday ? `${purpleMui._600}` : `${greyMui._600}`};
  }
`;
